module.exports = __webpack_public_path__ + "static/jirousek-12c8ff72fe657b4923b578feff9ee318.jpg";